// import FindEmployee from "components/ui/FindEmployee";
import Hero from "components/ui/EnumeratorHero";

const EnumeratorHomePage = () => {
  return (
    <>
    <></>
      <Hero />
      {/* <FindEmployee /> */}
    </>
  );
};

export default EnumeratorHomePage;
